import * as React from "react"
import { cn } from "@/lib/utils"
import { AlertCircle } from "lucide-react"
import { motion } from "motion/react"

export function AuthField({
  label,
  hint,
  error,
  children,
}: {
  label: string
  hint?: string
  error?: string
  children: React.ReactNode
}) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-baseline justify-between">
        <label className="text-2xs font-medium uppercase tracking-[0.16em] text-muted-foreground/80">
          {label}
        </label>
        {hint && !error && (
          <span className="text-2xs text-muted-foreground/50">{hint}</span>
        )}
      </div>
      {children}
      {error && (
        <motion.div
          initial={{ opacity: 0, y: -3 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.15 }}
          className="flex items-start gap-1.5 pt-0.5 text-xs text-rose-400"
        >
          <AlertCircle className="mt-px h-3 w-3 shrink-0" />
          <span>{error}</span>
        </motion.div>
      )}
    </div>
  )
}

export function AuthErrorBanner({ message }: { message: string }) {
  return (
    <motion.div
      role="alert"
      initial={{ opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.18 }}
      className="flex items-start gap-2.5 rounded-lg border border-rose-500/20 bg-rose-500/6 px-3 py-2.5 text-sm text-rose-300"
    >
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0" />
      <span className="leading-snug">{message}</span>
    </motion.div>
  )
}

export function AuthDivider({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "pointer-events-none h-px bg-linear-to-r from-transparent via-border to-transparent",
        className,
      )}
    />
  )
}
